
// current url is temporary modal
// example: /agreement/user?modal
export const ModalQueryFlag = '?modal';